var _ellipse, _rect, _path, _path2, _ellipse2, _path3, _path4, _path5, _path6, _ellipse3, _path7, _circle, _circle2, _circle3, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAhavibes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 260",
    fill: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 200,
    cy: 215,
    rx: 55,
    ry: 10,
    stroke: "#38bdf8",
    strokeOpacity: 0.2,
    strokeWidth: 1
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 175,
    width: 50,
    height: 40,
    rx: 6,
    stroke: "#38bdf8",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M185 195h30",
    stroke: "#38bdf8",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M200 175 L200 130",
    stroke: "#38bdf8",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 200,
    cy: 115,
    rx: 38,
    ry: 32,
    stroke: "#fafcfb",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M170 105 Q200 75 230 105 Q200 135 170 105",
    stroke: "#fbbf24",
    strokeWidth: 1.5,
    strokeOpacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M178 98 Q200 88 222 98 M175 115 Q200 105 225 115",
    stroke: "#38bdf8",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M185 108 Q200 100 215 108 M182 118 Q200 110 218 118",
    stroke: "#38bdf8",
    strokeWidth: 1,
    opacity: 0.6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M130 155 Q110 130 125 110",
    stroke: "#fafcfb",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 118,
    cy: 108,
    rx: 14,
    ry: 10,
    stroke: "#38bdf8",
    strokeWidth: 1.5,
    transform: "rotate(-20 118 108)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M108 100 L100 95",
    stroke: "#38bdf8",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 175,
    cy: 125,
    r: 3,
    fill: "#38bdf8",
    opacity: 0.7
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 185,
    cy: 135,
    r: 2.5,
    fill: "#38bdf8",
    opacity: 0.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 140,
    r: 2,
    fill: "#38bdf8",
    opacity: 0.4
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M290 85 Q295 75 300 85 Q295 95 290 85",
    stroke: "#fbbf24",
    strokeWidth: 1.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M95 75 Q100 65 105 75 Q100 85 95 75",
    stroke: "#38bdf8",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAhavibes);
export default __webpack_public_path__ + "static/media/ahavibes.b798f7683da16817c1f30886760963d7.svg";
export { ForwardRef as ReactComponent };